import React, { useEffect, useState } from 'react';
import { Phone, Menu, X, ChevronDown } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Ceramic Coating',
    href: '#ceramic'
  }, {
    name: 'Booking',
    href: '#booking'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'About Us',
    href: '#about'
  }, {
    name: 'Contact Us',
    href: '#contact'
  }];
  const serviceLinks = ['Car Detailing', 'RV Detailing', 'Boat Detailing', 'Aircraft Detailing', 'Motorcycle Detailing', 'Fleet Detailing'];
  return <nav className={`fixed left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-[#111111]/95 backdrop-blur-md border-b border-white/10 py-3 top-0' : 'bg-[#111111] lg:bg-transparent py-6 top-[40px] lg:top-[40px]'}`} data-id="element-88">
      <div className="container mx-auto px-4 md:px-6" data-id="element-89">
        <div className="flex items-center justify-between" data-id="element-90">
          {/* Logo */}
          <a href="#" className="flex-shrink-0" data-id="element-91">
            <img src="https://cdn.magicpatterns.com/uploads/ao7H2snqoFJ8NyhUCzjmFe/Capstone_v3.png" alt="Capstone Mobile Detailing" className="h-12 md:h-16 w-auto object-contain" data-id="element-92" />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-93">
            {/* Services Dropdown */}
            <div className="relative group" data-id="element-94">
              <button className="flex items-center text-white/90 hover:text-[#7FD4D4] font-medium text-sm transition-colors py-2" onMouseEnter={() => setIsServicesOpen(true)} onMouseLeave={() => setIsServicesOpen(false)} data-id="element-95">
                Mobile Detailing <ChevronDown size={14} className="ml-1" data-id="element-96" />
              </button>

              {/* Dropdown Menu */}
              <div className={`absolute top-full left-0 w-48 bg-[#1A1A1A] border border-white/10 shadow-xl rounded-sm overflow-hidden transition-all duration-200 origin-top ${isServicesOpen ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0 pointer-events-none'}`} onMouseEnter={() => setIsServicesOpen(true)} onMouseLeave={() => setIsServicesOpen(false)} data-id="element-97">
                <div className="py-2" data-id="element-98">
                  {serviceLinks.map(service => <a key={service} href="#services" className="block px-4 py-2 text-sm text-white/80 hover:bg-[#222] hover:text-[#7FD4D4] transition-colors" data-id="element-99">
                      {service}
                    </a>)}
                </div>
              </div>
            </div>

            {navLinks.map(link => <a key={link.name} href={link.href} className="text-white/90 hover:text-[#7FD4D4] font-medium text-sm transition-colors" data-id="element-100">
                {link.name}
              </a>)}
          </div>

          {/* Right Side Actions */}
          <div className="hidden lg:flex items-center space-x-6" data-id="element-101">
            <a href="tel:602-641-5089" className="flex items-center text-white font-semibold hover:text-[#7FD4D4] transition-colors" data-id="element-102">
              <Phone size={16} className="mr-2 text-[#7FD4D4]" data-id="element-103" />
              602-641-5089
            </a>
            <a href="#booking" className="bg-[#7FD4D4] text-black px-6 py-2.5 rounded-sm font-bold text-sm hover:bg-[#6BC4C4] transition-colors" data-id="element-104">
              Book Now
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden text-white p-2 z-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-105">
            {isMobileMenuOpen ? <X size={24} data-id="element-106" /> : <Menu size={24} data-id="element-107" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`lg:hidden fixed inset-0 z-50 bg-[#111111] transition-transform duration-300 ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-108">
        {/* Close button */}
        <div className="absolute top-6 right-6" data-id="element-109">
          <button onClick={() => setIsMobileMenuOpen(false)} className="text-white p-2 hover:bg-white/10 rounded-full transition-colors" aria-label="Close menu" data-id="element-110">
            <X size={28} data-id="element-111" />
          </button>
        </div>

        <div className="flex flex-col space-y-6 overflow-y-auto h-full pb-24 pt-24 px-6" data-id="element-112">
          <div className="border-b border-white/10 pb-4" data-id="element-113">
            <p className="text-[#7FD4D4] text-xs font-bold uppercase tracking-wider mb-4" data-id="element-114">
              Services
            </p>
            {serviceLinks.map(service => <a key={service} href="#services" className="block py-2 text-lg text-white font-medium" onClick={() => setIsMobileMenuOpen(false)} data-id="element-115">
                {service}
              </a>)}
          </div>

          {navLinks.map(link => <a key={link.name} href={link.href} className="text-xl text-white font-medium" onClick={() => setIsMobileMenuOpen(false)} data-id="element-116">
              {link.name}
            </a>)}

          <div className="pt-6 border-t border-white/10 flex flex-col space-y-4" data-id="element-117">
            <a href="tel:602-641-5089" className="flex items-center text-xl text-white font-bold" data-id="element-118">
              <Phone size={20} className="mr-3 text-[#7FD4D4]" data-id="element-119" />
              602-641-5089
            </a>
            <a href="#booking" className="bg-[#7FD4D4] text-black py-4 rounded-sm font-bold text-center text-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-120">
              Book Now
            </a>
          </div>
        </div>
      </div>
    </nav>;
}